// FEAT-045 (#241): warranty 겹침 판정 순수 util (React/redux 비의존, 외부 IO 없음)
//
// SoT 미러 경고: 아래 rangesOverlap 규칙은 BE
//   repos/rayguard-api/src/libs/warrantyPolicyValidation.js 의 rangesOverlap 과
//   문자 그대로 동일해야 한다: f1 <= t2 && f2 <= t1 (경계 접촉도 겹침으로 간주).
// 한쪽만 수정하면 FE 미리보기와 BE 저장 결과(validateStandards, 2차 방어)가
// 불일치하게 되므로, 규칙을 변경할 때는 반드시 양쪽을 함께 수정한다.

export const rangesOverlap = (f1, t1, f2, t2) => f1 <= t2 && f2 <= t1;

/**
 * candidateModels 각 모델에 대해, newStandards 와 existingStandardsByModel 을
 * cross 비교하여 (baseDate, type) 이 같고 구간이 겹치는 쌍을 conflicts 로 모은다.
 * BE validateStandards(문서 내부 검증)와 달리, FE 일괄 Add 시 "겹치는 모델만
 * 스킵"하는 best-effort 1차 방어선이다.
 *
 * @returns {Array<{model: string, conflicts: Array}>}
 */
export const computeModelOverlaps = (candidateModels, newStandards, existingStandardsByModel) => {
    if (!Array.isArray(candidateModels) || candidateModels.length === 0) return [];

    const incomingList = Array.isArray(newStandards) ? newStandards : [];
    const existingMap = existingStandardsByModel && typeof existingStandardsByModel === 'object' ? existingStandardsByModel : {};

    return candidateModels.map((model) => {
        const existingList = Array.isArray(existingMap[model]) ? existingMap[model] : [];
        const conflicts = [];

        incomingList.forEach((incoming) => {
            existingList.forEach((existing) => {
                if (!incoming || !existing) return;
                if (incoming.baseDate !== existing.baseDate || incoming.type !== existing.type) return;
                if (!Number.isFinite(incoming.from) || !Number.isFinite(incoming.to)) return;
                if (!Number.isFinite(existing.from) || !Number.isFinite(existing.to)) return;

                if (rangesOverlap(incoming.from, incoming.to, existing.from, existing.to)) {
                    conflicts.push({
                        baseDate: incoming.baseDate,
                        type: incoming.type,
                        incoming: { from: incoming.from, to: incoming.to },
                        existing: { from: existing.from, to: existing.to },
                    });
                }
            });
        });

        return { model, conflicts };
    });
};
